import { dyeColors, makeStyles, ModeOptions } from '~styles';

export const useStyles = makeStyles()(({ mode }) => {
	return {
		root: {
			color: mode === ModeOptions.Dye ? dyeColors.main : undefined,
		},
	};
});
